import { convertStyledToStyledVerbosed } from './convertSxToSxVerbosed';
import { stableHash } from './stableHash';
import { resolvePlatformTheme } from './utils';
import { updateOrderUnResolvedMap } from './updateOrderUnResolvedMap';
export const createGlobalStyles = (globalStyle, Platform) => {
  const versboseComponentTheme = convertStyledToStyledVerbosed(globalStyle);
  resolvePlatformTheme(versboseComponentTheme, Platform.OS);
  const componentHash = stableHash({
    ...globalStyle
  });
  const {
    styledIds,
    verbosedStyleIds
  } = updateOrderUnResolvedMap(versboseComponentTheme, componentHash, 'global', {});
  return {
    globalStyleIds: styledIds,
    globalVerbosedStyleIds: verbosedStyleIds,
    globalTheme: versboseComponentTheme
  };
};
//# sourceMappingURL=createGlobalStyles.js.map